import { formatMessage } from "../translations/format-message";
import * as Yup from "yup";

export const validateNumber = (min: number, max: number, notRequired?: boolean) => {
  const minMaxLengthMsg = formatMessage('Number_Min_Max_Length_Validation').replace('{minValue}', `${min}`).replace('{maxValue}', `${max}`);
  const schema = Yup.number()
    .test('isRequired', (value: any, ctx) => {
      if (value === -999 && !notRequired) {
        return ctx.createError({ message: 'Required_Validation' });
      }
      else if (value !== -999 && (value > max || value < min))
        return ctx.createError({ message: minMaxLengthMsg });
      else
        return true;
    })

  return schema;
}

export const validateString = (max: number, notRequired?: boolean) => {
  const maxLengthMsg = formatMessage('String_Max_Length_Validation').replace('{maxLength}', `${max}`);
  const schema = Yup.string()
    .max(max, maxLengthMsg)

  return notRequired ? schema : schema.required('Required_Validation').test((value, ctx: any) => {
    return (!value?.replace(/\s/g, '').length) ? ctx.createError({ message: "Required_Validation" }) : true
  })
}

export const validateEmail = (max: number, notRequired?: boolean) => {
  const maxLengthMsg = formatMessage('String_Max_Length_Validation').replace('{maxLength}', `${max}`);
  const schema = Yup.string()
    .matches(
      /^([一-龠ぁ-ゔァ-ヴー々〆〤a-zA-Z0-9._%-]+@[一-龠ぁ-ゔァ-ヴー々〆〤a-zA-Z0-9.-]+\.[一-龠ぁ-ゔァ-ヴー々〆〤a-zA-Z]{2,6})$/,
      "Email_Validation_Invalid"
    )
    
    .max(max, maxLengthMsg)

  return notRequired ? schema : schema.required('Required_Validation');
}

export const validatePassword = (max: number) => {
  const maxLengthMsg = formatMessage('String_Max_Length_Validation').replace('{maxLength}', `${max}`);
  return Yup.string()
    .matches(
      /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{3,}$/,
      "Password_Validation_Matches"
    )
    .required("Required_Validation")
    .max(max, maxLengthMsg)
}

export const validateRequired = (notRequired?: boolean) => {
  const schema = Yup.string()
  return notRequired ? schema : schema.required('Required_Validation').test((value, ctx: any) => {
    return (!value?.replace(/\s/g, '').length) ? ctx.createError({ message: "Required_Validation" }) : true
  })
}

export function toHalfWidth(input: any) {
  return String(input)
    // Convert full-width chars in the range FF01–FF5E (includes letters, numbers, symbols)
    .replace(/[\uFF01-\uFF5E]/g, ch =>
      String.fromCharCode(ch.charCodeAt(0) - 0xFEE0)
  )
    // Convert full-width space (U+3000) to half-width space (U+0020)
    .replace(/\u3000/g, ' ');
}